import { useState } from 'react';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { PendingBudgetChange } from '../../types';

interface UseGenericBudgetChangesProps {
  bulkSaveUrl: string;
}

export const useBudgetChanges = ({
  bulkSaveUrl,
}: UseGenericBudgetChangesProps) => {
  const [pendingBudgetChanges, setPendingBudgetChanges] = useState<
    Map<number, PendingBudgetChange>
  >(new Map());
  const [bulkSaveLoading, setBulkSaveLoading] = useState(false);

  const addPendingChange = (entityId: number, change: PendingBudgetChange) => {
    const newPendingChanges = new Map(pendingBudgetChanges);
    newPendingChanges.set(entityId, change);
    setPendingBudgetChanges(newPendingChanges);
  };

  const clearPendingChanges = () => {
    setPendingBudgetChanges(new Map());
  };

  const bulkSaveSystemBudgets = async (
    validateAllDepartmentBudgets: () => boolean,
    onValidationError: () => void,
    onSuccess: () => Promise<void>,
  ) => {
    if (!validateAllDepartmentBudgets()) {
      onValidationError();
      return;
    }

    setBulkSaveLoading(true);
    try {
      const budgetChanges = Array.from(pendingBudgetChanges.values());
      await fetchWrapper.post(bulkSaveUrl, {
        budgets: budgetChanges,
      });

      setPendingBudgetChanges(new Map());
      await onSuccess();
    } catch (error) {
      console.error('Error saving system budgets:', error);
    } finally {
      setBulkSaveLoading(false);
    }
  };

  const bulkSaveBudgets = async (
    validateAllBudgets: () => boolean,
    onValidationError: () => void,
    onSuccess: () => Promise<void>,
  ) => {
    if (!validateAllBudgets()) {
      onValidationError();
      return;
    }

    setBulkSaveLoading(true);
    try {
      const budgetChanges = Array.from(pendingBudgetChanges.values());
      await fetchWrapper.post(bulkSaveUrl, {
        budgets: budgetChanges,
      });

      setPendingBudgetChanges(new Map());
      await onSuccess();
    } catch (error) {
      console.error('Error saving budgets:', error);
    } finally {
      setBulkSaveLoading(false);
    }
  };

  return {
    pendingBudgetChanges,
    bulkSaveLoading,
    addPendingChange,
    clearPendingChanges,
    bulkSaveBudgets,
    bulkSaveSystemBudgets,
  };
};
